import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import { CircleLoader, PageContent } from "components"
import { useContext } from "react";
import { productInfoContext } from "../ProductCheckContext";

let Results = () => {
    let service = useContext(productInfoContext);

    return (
        <PageContent>
            {service.isSearching === true && <CircleLoader />}
            {service.isSearching === false && service.isSearchDone === true &&
                <>
                    {!service.productInfo &&
                        <Typography variant="subtitle2" style={{ marginTop: 24, marginLeft: 16 }}>Product not found or invalid</Typography>
                    }
                    {service.productInfo &&
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>SKU</TableCell>
                                    <TableCell>Brand</TableCell>
                                    <TableCell>QrCode Mandatory</TableCell>
                                    <TableCell>QrCode Present</TableCell>
                                    <TableCell>Warranty Months</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{service.productInfo.sku}</TableCell>
                                    <TableCell>{service.productInfo.brandCode}</TableCell>
                                    <TableCell>{service.productInfo.isQrMandatory ? 'Yes' : 'No'}</TableCell>
                                    <TableCell>{service.productInfo.isQrPresent ? 'Yes' : 'No'}</TableCell>
                                    <TableCell>
                                        {service.productInfo.unlimited ? 'Unlimited' : service.productInfo.warrantyExtensionMonths}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    }
                </>
            }
        </PageContent>
    )
}

export default Results;